import { ElectronApi } from '@/services/electron.api';
import { testAccess } from '../fs/fs-extra.utils';
import CryptoJS from 'crypto-js';

/**
 * 流式计算文件的 SHA256，避免将大文件整体加载到内存
 */
const streamSha256 = async (
  fs: NonNullable<typeof ElectronApi.fs>,
  fileName: string
): Promise<string> => {
  const hasher = CryptoJS.algo.SHA256.create();
  const CHUNK_SIZE = 64 * 1024; // 64KB per chunk
  const stat = await fs.promises.stat(fileName);
  const fileSize = stat.size;
  // 使用 fd + read 分块读取，避免一次性加载大文件
  const fd = fs.openSync(fileName, 'r');
  try {
    const buf = Buffer.alloc(CHUNK_SIZE);
    let pos = 0;
    while (pos < fileSize) {
      const bytesRead = fs.readSync(fd, buf, 0, CHUNK_SIZE, pos);
      const chunk = bytesRead < CHUNK_SIZE ? buf.subarray(0, bytesRead) : buf;
      hasher.update(
        CryptoJS.lib.WordArray.create(chunk as unknown as number[])
      );
      pos += bytesRead;
    }
  } finally {
    fs.closeSync(fd);
  }
  return hasher.finalize().toString(CryptoJS.enc.Hex);
};

export const saveHashFile = async (watchfacePath: string) => {
  const path = ElectronApi.path;
  const fs = ElectronApi.fs;
  if (!fs || !path) return;
  const hashCodeList = [];
  const capabilitySetPath = path.join(watchfacePath, 'capability.json');
  const xmlPath = path.join(watchfacePath, 'resources/manifest.xml');
  const binPath = path.join(watchfacePath, 'resource.bin');
  const hashFileName = [capabilitySetPath, xmlPath, binPath];
  for (const fileName of hashFileName) {
    if (!(await testAccess(fileName))) continue;
    const sha256Code = await streamSha256(fs, fileName);
    if (!sha256Code) continue;
    hashCodeList.push(sha256Code);
  }
  const hashCode = hashCodeList.join(',');
  const hashPath = path.join(watchfacePath, 'hashCode');
  await fs.promises.writeFile(hashPath, hashCode);
};
